"use strict";

(function () {
  'use strict';

  angular.module('lr.Nav').service('appNavService', [function () {
    /**
     * Navigation Items go here
     * @type {*[]}
     */
    this.navItems = [{
      'name': 'Dashboard',
      'href': '/',
      'icon': 'fa fa-bar-chart'
    }, {
      'name': 'Property Manager',
      'href': '/property-state-manager',
      'icon': 'fa fa-home'
    }, {
      'name': 'Work Orders',
      'href': '/work-orders',
      'openInNewWindow': true,
      'icon': 'fa fa-file-text-o'
    }];
  }]);
})();